// Mock data for Medic on the Move website

// Removed fake testimonials - real ones will come from database
export const testimonials = [];

export const services = [
  {
    id: 1,
    category: "Medical Consultations & Examinations",
    icon: "Stethoscope",
    items: [
      "Thorough medical history assessment and physical examinations",
      "Personalised, one-on-one patient counselling",
      "Antenatal counselling",
      "Mental Health & Well-being Counseling",
      "Fertility Counseling",
      "Geriatric Care",
      "Pediatric Care"
    ]
  },
  {
    id: 2,
    category: "Medical Management & Emergency Care",
    icon: "Heart",
    items: [
      "Acute & chronic disease management",
      "Medical emergency management",
      "HIV testing with pre-and-post-test counselling",
      "Infection and pain management",
      "IV Rehydration and Immune booster therapy",
      "Iron transfusions (for anemia)",
      "Basic wound care",
      "Minor procedures"
    ]
  },
  {
    id: 3,
    category: "Specialist & Diagnostic Referrals",
    icon: "FileText",
    items: [
      "Specialist and hospital referrals",
      "X-ray and ultrasound referrals",
      "Laboratory specimen collection"
    ]
  },
  {
    id: 4,
    category: "Certifications & Documentation",
    icon: "FileCheck",
    items: [
      "Certificate of absence (sick notes)",
      "Medical examination/report for employment purposes",
      "Professional Driving Permit (PDP) medical assessments"
    ]
  },
  {
    id: 5,
    category: "Prescriptions & Follow-Ups",
    icon: "Pill",
    items: [
      "Prescription services (script-writing)",
      "Follow-up consultations for continued care"
    ]
  }
];

export const packages = [
  {
    id: 1,
    name: "Home Visit",
    duration: "Up to 1 hour",
    price: "R550",
    features: [
      "Doctor's consultation",
      "Personalised medication package",
      "Minor procedures"
    ],
    popular: true,
    deposit: "R200"
  },
  {
    id: 2,
    name: "Virtual Consultation",
    duration: "30 minutes",
    price: "R200",
    features: [
      "Online medical consultation with a doctor"
    ],
    popular: false,
    deposit: "R100"
  },
  {
    id: 3,
    name: "Lab Workup",
    duration: "Virtual Results",
    price: "R100",
    features: [
      "Virtual Results analysis with detailed feedback"
    ],
    popular: false,
    deposit: "N/A"
  },
  {
    id: 4,
    name: "Follow-Up Appointment",
    duration: "Ongoing",
    price: "R400",
    features: [
      "Ongoing consultation for treatment",
      "Monitoring and progress assessment"
    ],
    popular: false,
    deposit: "N/A"
  }
];

export const serviceAreas = [
  "Durban North",
  "Westville",
  "Pinetown",
  "New Germany",
  "Kloof",
  "Hillcrest",
  "Overport",
  "Sherwood",
  "Musgrave",
  "Reservoir Hills",
  "North Beach",
  "Chatsworth",
  "Phoenix",
  "Queensburgh",
  "Umbilo"
];

// Mock booking submission
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Booking submitted:', bookingData);
      resolve({ success: true, message: 'Booking request received! We will contact you shortly.' });
    }, 1000);
  });
};

// Mock contact form submission
export const submitContact = async (contactData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', contactData);
      resolve({ success: true, message: 'Message sent! We will get back to you soon.' });
    }, 1000);
  });
};
